import React, { useMemo } from 'react';
import { CTitle, TTitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useStore } from '../../../../store';
import TrendTop from '../../../../../../assets/cybersecurity2026/topic1600/trend-top.png';

interface ISection0Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const { updateParagraphState } = useStore();

  React.useEffect(() => {
    updateParagraphState(p_course, p_topic, ID, 'completed', []);
  }, []);
  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.title} />
      <div className="new-trend">
        <div className="trend-top">
          <div className="trend-top-bubble">
            {paragraphsSettings?.trendTitle}
          </div>
          <img className="trend-top-img" src={TrendTop} alt="" />
        </div>
        <div className="trend-table">
          <div className="trend-table-header">
            {paragraphsSettings?.tableHeaders?.map(
              (header: any, index: number) => (
                <div key={index} className="trend-table-header-cell">
                  {header}
                </div>
              )
            )}
          </div>
          <div className="trend-table-body">
            {paragraphsSettings?.tableData?.map((row: any, index: number) => (
              <div
                key={index}
                className={`trend-table-row ${
                  index % 2 === 1 ? 'even-row' : ''
                }`}
              >
                <div className="trend-table-cell">{row.trend}</div>
                <div className="trend-table-cell">{row.description}</div>
                <div className="trend-table-cell">{row.impact}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="use">
        <TTitle title={paragraphsSettings?.tips1} />
        <div className="use-action">
          {paragraphsSettings?.tipsList.map((item: any, i: number) => (
            <div className={'use-box'} key={i}>
              <div className="use-item">
                <div className={`use-item-back back-${i + 1}`}>
                  <div
                    className="use-item-title"
                    dangerouslySetInnerHTML={{ __html: item?.text }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default React.memo(Section2);
